import React, {useCallback, useEffect, useRef, useState} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import qs from "qs"
import TextField from "@material-ui/core/TextField";
import SearchIcon from '@material-ui/icons/Search';
import { useHistory, useLocation } from 'react-router-dom';
import {debounce} from "@material-ui/core";
const useStyles = makeStyles((theme)=>({
    searchInput: {
        minWidth: 200,
        '&  >  div': {
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #e5e4e4',
            padding: '8px 0',
            '& svg path': {
                fill: '#fff'
            },
            '& .MuiFilledInput-root': {
                backgroundColor: 'transparent',
                marginLeft: 5,
                '&::before': {
                    display: 'none'
                },
                '&::after': {
                    display: 'none'
                }
            },
            '& input': {
                padding: 8,
                color: '#fff'
            }
        }
    }
}));
function useQuery() {
    return new URLSearchParams(useLocation().search);
}
function SearchInput(propsPre) {
    const classes = useStyles()
    const history = useHistory();
    const location = useLocation();
    const query = useQuery();
    const prevSearchValueRef = useRef(null); 
    const [search, setSearch] =  useState(query.get('search')  || "");
    const debouncedFetch = useCallback(debounce((value)=> {
        let urlParams = new URLSearchParams(window.location.search);
        urlParams.set("search", value)
        // const urlParams = qs.parse(location.search, {ignoreQueryPrefix: true});
        // history.push(location.pathname + '?' + qs.stringify({...urlParams, search: value}));
        history.push(location.pathname + '?' + urlParams.toString());
        propsPre.resetListFnc()
    }, 500), []);
  
    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const currentSearchValue = params.get('search');
  
      if (prevSearchValueRef.current !== currentSearchValue) {
        setSearch(currentSearchValue)
        prevSearchValueRef.current = currentSearchValue;
      }
    }, [location.search]); 

    const changeSearchText = (e) => {
        const value = e.target.value
        setSearch(value);

        if (e.key === 'Enter' || e.keyCode === 13) {
            const urlParams = qs.parse(location.search, {ignoreQueryPrefix: true});
            history.push(location.pathname + '?' + qs.stringify({...urlParams, search: value}));
            propsPre.resetListFnc()
        } else {
            debouncedFetch(value);
        }
    }


    return (
        <div className={classes.searchInput}>
            <div>
                <SearchIcon/>
                <TextField
                    variant={"filled"}
                    value={search ?? ""}
                    onKeyPress={(e) => changeSearchText(e)}
                    onChange={(e) => changeSearchText(e)}

                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        dataUser: state.authReducer.dataUser,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

SearchInput.defaultProps = {
    apiParamsList: {},
    resetListFnc: () => {
    }
}

SearchInput.propTypes = {
    className: PropTypes.string,
    resetListFnc: PropTypes.func
}


export default compose(connect(mapStateToProps, mapDispatchToProps),
    withRouter
)(SearchInput);
